var map = {
	"./cp-abundance-1.svg": "83b0",
	"./cp-abundance-2.svg": "7204",
	"./cp-abundance-3.svg": "d54d",
	"./cp-abundance-4.svg": "db03",
	"./cp-admin.svg": "6967",
	"./cp-camera.svg": "84e1",
	"./cp-diver-1.svg": "09e9",
	"./cp-diver-2.svg": "e35d",
	"./cp-diver-3.svg": "814d",
	"./cp-edit.svg": "a747",
	"./cp-event-current.svg": "c0a7",
	"./cp-event-date.svg": "aa11",
	"./cp-event-depth.svg": "c829",
	"./cp-event-duration.svg": "d867",
	"./cp-event-habitat.svg": "66b9",
	"./cp-event-temperature.svg": "6cf8",
	"./cp-event-visibility.svg": "b1a0",
	"./cp-fish-1.svg": "5100",
	"./cp-home.svg": "7bce",
	"./cp-library-fisheries-1.svg": "8c8c",
	"./cp-library-fisheries-2.svg": "6772",
	"./cp-library-info.svg": "8fca",
	"./cp-library-metrics.svg": "0fc1",
	"./cp-library-reference.svg": "bd77",
	"./cp-library.svg": "8245",
	"./cp-logo-1.svg": "85a7",
	"./cp-logo-2.svg": "fd46",
	"./cp-map-area.svg": "425b",
	"./cp-map-marker.svg": "0d6e",
	"./cp-no-image.svg": "7e38",
	"./cp-outlined-diver-1.svg": "dea3",
	"./cp-outlined-diver-2.svg": "1af0",
	"./cp-outlined-fish-1.svg": "c9ec",
	"./cp-outlined-fish-2.svg": "2572",
	"./cp-outlined-map.svg": "8aa9",
	"./cp-password.svg": "e96d",
	"./cp-search.svg": "8391",
	"./cp-user.svg": "bb50",
	"./cp-zoom-in.svg": "a87d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "368c";